var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 10,
    viewBox: "0 0 33 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1353 9.74688H11.4929L13.1456 0.173523H15.7879L14.1353 9.74688Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7144 0.407576C23.1932 0.213872 22.3665 0 21.3443 0C18.7348 0 16.8972 1.30354 16.886 3.1672C16.8643 4.54221 18.2016 5.30593 19.2019 5.7644C20.2242 6.23289 20.5717 6.53867 20.5717 6.95626C20.5613 7.59761 19.7456 7.89324 18.9848 7.89324C17.9298 7.89324 17.3646 7.74082 16.5055 7.38401L16.1576 7.23105L15.7878 9.38006C16.4075 9.64456 17.5494 9.87927 18.7348 9.88956C21.5075 9.88956 23.3125 8.60619 23.3339 6.62016C23.3445 5.53036 22.6383 4.69531 21.1159 4.01295C20.1917 3.57492 19.6257 3.27956 19.6257 2.83137C19.6365 2.42393 20.1044 2.00661 21.1477 2.00661C22.0067 1.98617 22.6379 2.1796 23.116 2.37317L23.355 2.47483L23.7144 0.407576V0.407576V0.407576Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4443 0.173523H30.4882L32.62 9.74674H30.1734C30.1734 9.74674 29.9339 8.64679 29.8581 8.31069H26.4654C26.3673 8.56517 25.9108 9.74674 25.9108 9.74674H23.1382L27.0632 0.967828C27.3351 0.346516 27.814 0.173523 28.4443 0.173523ZM28.2814 3.67682C28.2814 3.67682 27.4441 5.80539 27.2264 6.35537H29.4228C29.3142 5.87672 28.8138 3.58518 28.8138 3.58518L28.6291 2.76028C28.5513 2.9727 28.4389 3.26474 28.363 3.46172C28.3116 3.59524 28.277 3.68507 28.2814 3.67682Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0434941 0.173523H4.29493C4.8712 0.193692 5.33879 0.36682 5.49095 0.978251L6.41488 5.37671C6.41498 5.37703 6.41508 5.37735 6.41518 5.37767L6.69796 6.70165L9.28579 0.173533H12.08L7.92649 9.73674H5.13218L2.77696 1.41833C1.96434 0.973285 1.03692 0.615349 0 0.366956L0.0434941 0.173523Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/VISA.2fa384c2fdcc84193258a23d6b0e461d.svg";
export { ForwardRef as ReactComponent };